import MatomoTracker from "@datapunt/matomo-tracker-js";

export const matomoTracker = new MatomoTracker({
  urlBase: "https://stats.mankenberg.com/",
  siteId: 6,
  trackerUrl: "https://stats.mankenberg.com/matomo.php",
  srcUrl: "https://stats.mankenberg.com/matomo.js",
});

